export default __webpack_public_path__ + "static/media/Convenios_on_light_blue.298ec825.svg";